var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E4FFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.8103 24.9946C25.4315 24.3661 23.7779 24 22 24C20.2221 24 18.5685 24.3661 17.1897 24.9946C16.0593 25.5099 15.5 26.7281 15.5 27.9704V30H28.5V27.9704C28.5 26.7281 27.9407 25.5099 26.8103 24.9946Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 21C23.933 21 25.5 19.433 25.5 17.5C25.5 15.567 23.933 14 22 14C20.067 14 18.5 15.567 18.5 17.5C18.5 19.433 20.067 21 22 21Z",
    fill: "#2C8C53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 30V27.9704C28.5 26.7281 27.9407 25.5099 26.8103 24.9946C25.4315 24.3661 23.7779 24 22 24C20.2221 24 18.5685 24.3661 17.1897 24.9946C16.0593 25.5099 15.5 26.7281 15.5 27.9704V30",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21C23.933 21 25.5 19.433 25.5 17.5C25.5 15.567 23.933 14 22 14C20.067 14 18.5 15.567 18.5 17.5C18.5 19.433 20.067 21 22 21Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/user-logo.5985eaa98d88e8d4c7d61fe48a27838a.svg";
export { ForwardRef as ReactComponent };